import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';

import { APP_DEFAULT_LANGUAGE, APP_SUPPORTED_LANGUAGES } from '../configs/app.config';

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: APP_SUPPORTED_LANGUAGES,

  // Used when no locale matches
  defaultLocale: APP_DEFAULT_LANGUAGE,
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
